import { createSlice } from '@reduxjs/toolkit';
import { fetchSchools, createSchool, updateSchool, deleteSchool } from '../thunks/schoolThunks';
import { reset } from '../actions/resetActions';

const initialState = {
  schools: [],
  loading: false,
  error: null,
  success: null,
  total: 0,
  currentPage: 1,
  limit: 10,
};

const schoolsSlice = createSlice({
  name: 'schools',
  initialState,
  reducers: {
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(reset, () => initialState)
      // Fetch Schools
      .addCase(fetchSchools.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(fetchSchools.fulfilled, (state, action) => {
        state.loading = false;
        state.schools = action.payload?.data?.schools || [];
        state.total = action.payload?.data?.pagination?.total || 1;
        state.currentPage = action.payload?.data?.pagination?.page || 1;
        state.limit = action.payload?.data?.pagination?.limit || 10;
        state.success = action.payload?.message;
      })
      .addCase(fetchSchools.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create School
      .addCase(createSchool.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(createSchool.fulfilled, (state, action) => {
        state.loading = false;
        state.schools.unshift(action.payload?.data?.school);
        state.success = action.payload?.message;
      })
      .addCase(createSchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update School
      .addCase(updateSchool.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(updateSchool.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.schools.findIndex(s => s._id === action.payload?.data?.school._id);
        if (index !== -1) {
          state.schools[index] = action.payload?.data?.school;
        }
        state.success = action.payload?.message;
      })
      .addCase(updateSchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete School
      .addCase(deleteSchool.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(deleteSchool.fulfilled, (state, action) => {
        state.loading = false;
        state.schools = state.schools.filter(s => s._id !== action.payload?.data?.school._id);
        state.success = action.payload?.message;
      })
      .addCase(deleteSchool.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSuccess, setError } = schoolsSlice.actions;
export default schoolsSlice.reducer; 